import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import PreLanding from "@/pages/PreLanding";
import Landing from "@/pages/Landing";
import Store from "@/pages/Store";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import Login from "@/pages/Login";
import AdminPortal from "@/pages/AdminPortal";
import ManufacturerPortal from "@/pages/ManufacturerPortal";
import { CartDrawer } from "@/components/site/CartDrawer";

function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<PreLanding />} />
              <Route path="/home" element={<Landing />} />
              <Route path="/store" element={<Store />} />
              <Route path="/saree/:id" element={<ProductDetail />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<AdminPortal />} />
              <Route path="/manufacturer" element={<ManufacturerPortal />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <CartDrawer />
          </BrowserRouter>
          <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#14110E", border: "1px solid rgba(212,175,55,0.3)", color: "#F5EFE6" } }} />
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
